/**
 * Used for asserting data has been loaded inside preloaders.
 * Null is not checked as this is a valid response value for missing entries
 */
export function assertDefined<T>(value: T | undefined | null, name: string): asserts value is T {
  if (value === undefined) {
    throw new Error(`${name} unexpectedly   undefined.`);
  }
}
